const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiAuthorization.PUBLIC, ApiDataModel.MEALS)

export const apiAddonsAsMeals = {
	fetchAddonMeals: async () => {
		const { data, meta } = await apiCommon<IDietMeal[]>(`${groupPrefix}`, {
			method: 'GET',
		})
		return { data: data.map(d => DietMeal(d)), meta }
	},

	fetchAddonMealpreps: async () => {
		const { data, meta } = await apiCommon<IDietMeal[]>(`${groupPrefix}`, {
			method: 'GET',
		})
		return { data: data.map(d => DietMeal(d)), meta }
	},
}
